export default "__VITE_ASSET__BMRJxLvs__"